exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-b1ab59d2]:export{menu-bgc-oragne:#F2C46D}.lang-select[data-v-b1ab59d2]{font-size:16px !important;display:inline-block}.lang-select span[data-v-b1ab59d2]{cursor:pointer}.lang-select span.active[data-v-b1ab59d2]{color:#1075F7}.lang-select span[data-v-b1ab59d2]:hover{color:#85BAE5}\n", ""]);

// exports
